export const GET_CLAIM = 'VerifyClaim/GET_CLAIM';
export const VERIFY_PAYMENT_INFO = 'VerifyClaim/VERIFY_PAYMENT_INFO';
export const VERIFY_COMPANY_NAME = 'VerifyClaim/VERIFY_COMPANY_NAME';
export const SET_MAIN_RADIO_GROUP = 'VerifyClaim/SET_MAIN_RADIO_GROUP';
export const SET_INFO_ERROR = 'VerifyClaim/SET_INFO_ERROR';
export const SET_IS_PROCEDURE_CODE = 'VerifyClaim/SET_IS_PROCEDURE_CODE';
export const RESET_STATE = 'VerifyClaim/RESET_STATE';
export const VALIDATE_CODE = 'VerifyClaim/VALIDATE_CODE';
export const SET_US_MAIL_SECURITY_GROUP =
  'VerifyClaim/SET_US_MAIL_SECURITY_GROUP';
export const TIN_ADDRESS_API = 'VerifyClaim/TIN_ADDRESS_API';
export const GENERATE_SECURITY_KEY = 'VerifyClaim/GENERATE_SECURITY_KEY';
